import { useState, useRef, useEffect, memo } from 'react';
import { motion } from 'framer-motion';
import { HelperCore } from '@/common/dependencies';

const ConnectionLine = props => {
  const { startPoint, endPoint, width, height, classNames, minY, minStartY, minEndY } = props;

  const svgRef = useRef(null);
  const [points, setPoints] = useState([]);
  const [draggedPoint, setDraggedPoint] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);

  // 生成平滑的贝塞尔曲线路径
  const generateCurvePath = (start, end) => {
    const dx = end.x - start.x;
    const dy = end.y - start.y;

    // 控制点偏移量，创建自然的曲线
    const controlOffset = Math.abs(dx) * 0.8;
    const cp1x = start.x + controlOffset;
    const cp1y = start.y;
    const cp2x = end.x - controlOffset;
    const cp2y = end.y;

    return `M ${start.x} ${start.y} C ${cp1x} ${cp1y}, ${cp2x} ${cp2y}, ${end.x} ${end.y}`;
  };

  // 处理鼠标拖拽
  const handleMouseDown = pointId => {
    setDraggedPoint(pointId);
  };

  const handleMouseMove = e => {
    if (!draggedPoint || !svgRef.current) return;

    const rect = svgRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    setPoints(prev =>
      prev.map(point =>
        point.id === draggedPoint ? { ...point, x, y } : point
      )
    );
  };

  const handleMouseUp = () => {
    setDraggedPoint(null);
  };

  useEffect(() => {
    setPoints([
      { x: startPoint.y <= minStartY ? startPoint.x + 10 : startPoint.x, y: startPoint.y, id: 'startPoint' },
      { x: endPoint.y <= minEndY ? endPoint.x - 10 : endPoint.x, y: endPoint.y, id: 'endPoint' },
    ]);
  }, [startPoint, endPoint]);


  if (!points[0] || !points[1]) return null;

  const pathData = generateCurvePath(points[0], points[1]);

  return (
    <svg
      ref={svgRef}
      width={width}
      height={height}
      className={classNames}
      // onMouseMove={handleMouseMove}
      // onMouseUp={handleMouseUp}
      // onMouseLeave={handleMouseUp}
    >
      {/* 连接线 */}
      <motion.path
        d={pathData}
        className={`${points[0].y <= minStartY && points[1].y <= minEndY ? 'hidden' : ''}`}
        fill="none"
        stroke="#7144FF"
        strokeWidth="2"
        strokeLinecap="round"
        initial={{ pathLength: 0 }}
        animate={{
          pathLength: 1,
          stroke: isAnimating
            ? ['#000000', '#7144FF', '#10b981', '#000000']
            : '#7144FF',
        }}
        transition={{
          pathLength: { duration: 0.8, ease: 'easeInOut' },
          stroke: {
            duration: 0.8,
            repeat: isAnimating ? Number.POSITIVE_INFINITY : 0,
          },
        }}
      />

      {/* 连接线的发光效果 */}
      {/* <motion.path
          d={pathData}
          fill="none"
          stroke="#7144FF"
          strokeWidth="8"
          strokeLinecap="round"
          opacity="0.3"
          filter="blur(4px)"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 1.5, ease: "easeInOut" }}
        /> */}

      {/* 节点 */}
      {points.map((point, index) => (
        <g 
          key={point.id} 
          className={`${(point.id == 'startPoint' && point.y <= minStartY) || (point.id == 'endPoint' && point.y <= minEndY) ? 'hidden' : ''}`}
        >
          {/* 节点阴影 */}
          <circle
            cx={point.x + 2}
            cy={point.y + 2}
            r="10"
            filter="blur(4px)"
            fill="rgba(113,68,255,0.5)"
          />

          {/* 节点主体 */}
          <motion.circle
            cx={point.x}
            cy={point.y}
            r="10"
            fill="#fff"
            stroke="#7144FF"
            strokeWidth="2"
            className="cursor-grab active:cursor-grabbing"
            onMouseDown={() => handleMouseDown(point.id)}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            animate={{
              scale: isAnimating ? [1, 1.2, 1] : 1,
              stroke: isAnimating
                ? ['#000000', '#7144FF', '#10b981', '#000000']
                : '#7144FF',
            }}
            transition={{
              scale: {
                duration: 0.5,
                repeat: isAnimating ? Number.POSITIVE_INFINITY : 0,
              },
              stroke: {
                duration: 2,
                repeat: isAnimating ? Number.POSITIVE_INFINITY : 0,
              },
            }}
          />
        </g>
      ))}

      {/* 动画粒子效果 */}
      {isAnimating && (
        <motion.circle
          r="3"
          fill="#ef4444"
          initial={{ offsetDistance: '0%' }}
          animate={{ offsetDistance: '100%' }}
          transition={{
            duration: 2,
            repeat: Number.POSITIVE_INFINITY,
            ease: 'linear',
          }}
          style={{
            offsetPath: `path('${pathData}')`,
            offsetRotate: '0deg',
          }}
        />
      )}
    </svg>
  );
};

export default ConnectionLine;
